import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_under_10_add_ons: FaireThemeEntity = {
  token: "discovery_theme_under-10-add-ons",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Under $10 Add-Ons",
  description: "Small buys that round out any order",
  bgColor: "#F0F0D4",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
